import { FC, useState } from 'react';
import {
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  useWindowDimensions,
} from 'react-native';
import { COLORS, FONTS } from '../../../constants';
import { useIsDesktop } from '../../../hooks/useIsDeskTop';

type HorizontalTabItem = {
  name: string;
  value: string;
  width: string;
};

interface HorizontalTabProps {
  current: string;
  setCurrent: (data: string) => void;
  tabs: HorizontalTabItem[];
}

const HorizontalTab: FC<HorizontalTabProps> = ({
  tabs,
  current,
  setCurrent,
}) => {
  const isDesktop = useIsDesktop();
  const handleTabPress = (index: string) => {
    setCurrent(index);
  };

  return (
    <View style={styles.container}>
      {tabs.map((tab, index) => (
        <TouchableOpacity
          key={tab.value}
          style={[
            styles.tab,
            tab.value === current && styles.selectedTab,
            { width: tab.width },
            !isDesktop() && {
              paddingVertical: 7,
            },
          ]}
          onPress={() => handleTabPress(tab.value)}
        >
          <Text
            style={[
              styles.tabText,
              tab.value === current && { color: COLORS.WHITE },
              !isDesktop() && {
                fontSize: 11,
              },
            ]}
          >
            {tab.name}
          </Text>
        </TouchableOpacity>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    borderWidth: 1,
    borderColor: COLORS.GREEN,
    borderRadius: 10,
    overflow: 'hidden',
  },
  tab: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 5,
    overflow: 'hidden',
  },
  selectedTab: {
    backgroundColor: COLORS.GREEN,
  },
  tabText: {
    textTransform: 'uppercase',
    fontSize: 15,
    color: COLORS.GREEN,
    fontFamily: FONTS.AvenirMedium,
    textAlign: 'center',
  },
});

export default HorizontalTab;
